import { notification } from 'antd';
import actions from './actions';
import { DataService } from '../../../config/dataService/dataService';

const GENERIC_API_ERROR = process.env.REACT_APP_GENERIC_ERROR_MESSAGE;

const {
  categoriaServiciosList,
  categoriaServiciosListSelectBox,
  categoriaServiciosCreate,
  categoriaServiciosRead,
  categoriaServiciosUpdate,
  categoriaServiciosDelete,  
} = actions;

const categoriaServiciosListAction = (paramBusqueda = '') => {
  return async dispatch => {
    try {
      const response = await DataService.get('/catalogos/categoriaServicios/list.php?paramBusqueda=' + paramBusqueda);      
      
      if (response.status === 200 && response.data.data) {       
        dispatch(categoriaServiciosList(response.data.data));
        return true
      }
      return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};


const categoriaServiciosCreateAction = data => {
  return async dispatch => {
    try {
      const response = await DataService.post('/catalogos/categoriaServicios/manage.php', data);
      if (response.status === 200) return true;
      else return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};

const categoriaServiciosReadAction = (id = '') => {
  return async dispatch => {
    try {
      if (id != '') {
        const response = await DataService.get('/catalogos/categoriaServicios/manage.php?id=' + id);
        if (response.status === 200 && response.data.data) {
          dispatch(categoriaServiciosRead(response.data.data));
          return true;
        }
      } else {
        dispatch(categoriaServiciosRead({}));
      }
      return false;
    } catch (err) {
      alert(GENERIC_API_ERROR);
    }
    return false;
  };
};

/////////////////

export {
  categoriaServiciosListAction,
  categoriaServiciosCreateAction,
  categoriaServiciosReadAction,    
};
